import { render, staticRenderFns } from "./TestimonialOne.vue?vue&type=template&id=02bdeb06&"
import script from "./TestimonialOne.vue?vue&type=script&lang=js&"
export * from "./TestimonialOne.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports